$(function(){

  $(document).on('change','.option-select-input',function(){
    var value = $(this).val();
   var option1 = $(document).find('[data-product-option="option1"]').val(),
       option2 =$(document).find('[data-product-option="option2"]').val(),
       option3 = $(document).find('[data-product-option="option3"]').val();
    if(option2 !== undefined){
      option1 += option2;
    }
    if(option3 !== undefined){
      option1 += option3;
    }
    $(document).find('[name="id"] option[data-selector="'+option1+'"]').prop('selected',true)
    console.log(option1);
  });
  
  
  $('.se-pre-con').hide();

  var fixedHeight= $('#shopify-section-static-header').height()+ 40 +'px';
  $('.site-main').css('margin-top',fixedHeight);

  $('body').on('click', '[name="subscribe"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('.check').is(':checked')) {
      $(this).submit();
    }
    else {
      if(window.location.href.indexOf(".de") > -1) 
      {
        alert("Bitte bestätige unsere AGB sowie unsere Datenschutzerklärung.");
        return false;
      }else{
        alert("Please confirm our terms and conditions as well as our privacy policy.");
        return false;
      }
    }
  });


  function topHeader(){
    var annoncement = $('#shopify-section-pxs-announcement-bar').height();
    if(annoncement>0){
      var topHeader = $('#shopify-section-static-header').css('top','67px');
    }else{
      var topHeader = $('#shopify-section-static-header').css('top','0');
    };
  };

  function responsiveWrapper(){
    var wrapperWidth = $('.site-main').width();
    var convertWidth = wrapperWidth + 'px';
    $('.swollen-wrapper').css({
      'margin-left':"calc(-100vw / 2 + " + convertWidth +  " / 2)",
      'margin-right':"calc(-100vw / 2 + " + convertWidth +  " / 2)"
    });
  };



  $(window).on('load',function(){
    topHeader();
    responsiveWrapper();
    if(window.location.href.indexOf(".de") > -1){
      $('.newselter-label').html("Bitte bestätige unsere <a href='/pages/agb' target='_blank' class='alternate-link'>AGB</a> sowie unsere <a href='/pages/data-privacy' target='_blank' class='alternate-link'>Datenschutzerklärung.</a> <a>Selbstverständlich kostenlos und jederzeit abbestellbar.</a>")
      $('.checker-term-label').html('Ich habe die <a href="/pages/agb" target="_blank">AGB</a> und <a href="/pages/data-privacy" target="_blank"> die Datenschutzerklärung</a> zur Kenntnis genommen</a>');
    }else{
      $('.checker-term-label').html('I accept the <a target="_blank" href="/pages/agb"> Terms and Conditions</a> as well as the <a target="_blank" href="/pages/data-privacy""> Privacy Policy</a> </a>.');
    };



  });
  // Show GIF Loading when page loading by ZAGO 
  //        var before_loadtime = new Date().getTime();

  //      window.onload = Pageloadtime;

  //      function Pageloadtime() {

  //          var aftr_loadtime = new Date().getTime();

  //          // Time calculating in seconds

  //          pgloadtime = aftr_loadtime - before_loadtime ;

  // //          document.getElementById("loadtime").innerHTML = "Pgae load time is <font color='red'><b>" + pgloadtime + "</b></font> Seconds";
  //          setTimeout(function(){ 
  //   	$('.se-pre-con').hide();
  //   }, pgloadtime);

  //      }


  // Checked conditions in cart page
  $('.cart-form .term-condition').click(function() {
    if (this.checked) {
      $('.checker-term').val("999");
    }
    else{
      $('.checker-term').val("0");
    }
  });
  $('.cart-menu-button-checkout').click(function(e){
    if ( $('.checker-term').val() ==0){
      if(window.location.href.indexOf(".de") > -1) 
      {
        alert("Bitte bestätige unsere AGB sowie unsere Datenschutzerklärung.");
        e.preventDefault();
      }else{
        alert("Please confirm our terms and conditions as well as our privacy policy.");
        e.preventDefault();
      }
    }else{
      $(this).submit();
    }


  });

  var $optionTitle = $('.product-wrapper .option .option-name');
  var optionName = $optionTitle.html();

  if(optionName === 'Title') {
    $optionTitle.css('display','none');
  }





  $(window).scroll(function(){
    var scrollLocation = $(window).scrollTop();
    if(scrollLocation >= 100){
      $('#shopify-section-static-header').css('top','0');
    }else if(scrollLocation==0){
      topHeader();
    };
  });

  $('.swollen-column').wrapAll("<div class='swollen-wrapper'></div>");

  $(window).on('resize',function(){
    responsiveWrapper()
  });

});


$(function(){
  $('.collection-header-description').appendTo('.collection-image')
});

$(document).on('click','.regSubmit',function(e){

  var first_name = $('#customer_first_name').val();
  var last_name = $('#customer_last_name').val();
  var email = $('#customer_email').val();
  var password = $('#customer_password').val();
  if ((first_name.length < 1) || (last_name.length < 1) || (email.length < 1) || (password.length < 8)) {
    $('.el_error').show();
    $(document).find('.el_overlay').css({'visibility':'visible','opacity':'1'});
  }  else {
    $('.el_popup').show();
    $('#create_customer').css('opacity','0.2');
    $(document).find('.el_overlay').css({'visibility':'visible','opacity':'1'});
  }
});
$(document).on('click','.el_confirm',function(){
  $(document).find('.input-wrapper [type="submit"]').trigger('click');
});

$(document).on('click','.errConfirm',function(){
  $('.el_error').hide();
  $(document).find('.el_overlay').css({'visibility':'hidden','opacity':'0'});
});

$(document).on('click','.page-template-collection .site-actions-cart',function(e){
  e.preventDefault();
  console.log("HERE")
});